import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  SignInButton,
  SignedIn,
  SignedOut,
  UserButton,
} from "@clerk/clerk-react";

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const logoContent = (
    <>
      <img src="/images/easyreports_logo.png" alt="EasyReports logo" style={{ height: 28, width: 28, objectFit: "contain" }} />
      EasyReports
    </>
  );

  const navLinkClass = (path) =>
    `text-sm font-medium text-muted-foreground no-underline px-3 py-[0.4rem] rounded-[6px] transition-colors hover:text-foreground hover:bg-accent${
      pathname === path ? " text-foreground bg-accent" : ""
    }`;

  return (
    <header
      className={`sticky top-0 z-50 flex items-center justify-between px-8 h-[60px] bg-background border-b border-border transition-[background,box-shadow,border-color] duration-200${
        scrolled
          ? " bg-background/95 backdrop-blur-[8px] shadow-[0_1px_16px_rgba(0,0,0,0.06)]"
          : ""
      }`}
    >
      <SignedOut>
        <Link
          to="/"
          className="flex items-center gap-2 font-display text-[1.1rem] text-foreground no-underline tracking-[-0.01em]"
        >
          {logoContent}
        </Link>
      </SignedOut>
      <SignedIn>
        <Link
          to="/dashboard"
          className="flex items-center gap-2 font-display text-[1.1rem] text-foreground no-underline tracking-[-0.01em]"
        >
          {logoContent}
        </Link>
      </SignedIn>

      <div className="flex items-center gap-3">
        <nav className="flex items-center gap-1 pr-3 border-r border-border">
          <Link to="/"        className={navLinkClass("/")}>Home</Link>
          <Link to="/pricing" className={navLinkClass("/pricing")}>Pricing</Link>
          <Link to="/about"   className={navLinkClass("/about")}>About</Link>
          <Link to="/contact" className={navLinkClass("/contact")}>Contact</Link>
        </nav>
        <SignedOut>
          <SignInButton mode="modal" afterSignInUrl="/dashboard" afterSignUpUrl="/dashboard">
            <button className="text-sm font-medium px-4 py-[0.45rem] rounded-[7px] border border-border bg-transparent text-foreground cursor-pointer transition-[border-color,background] hover:border-foreground hover:bg-accent">
              Sign in
            </button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <Link to="/dashboard">
            <button className="text-sm font-medium px-4 py-[0.45rem] rounded-[7px] bg-brand-800 text-white cursor-pointer transition-colors hover:bg-brand-700">
              Dashboard
            </button>
          </Link>
          <UserButton afterSignOutUrl="/" />
        </SignedIn>
      </div>
    </header>
  );
}
